import { BookmarkCheck, BookmarkPlus } from 'lucide-react-native';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, View } from 'react-native';
import { useWantToRead, useWantToReadActions } from '@/api/readings';
import { Button } from '@/components/ui/Button';
import { TextButton } from '@/components/ui/TextButton';
import { useTheme } from '@/theme';

/** Save a book for later, or, once it's on your shelf, take it off again. */
export function WantToggle({ editionId, bookKey, onError }: { editionId: string; bookKey: string; onError?: (err: unknown) => void }) {
  const { t } = useTranslation();
  const { colors, fontSize, space, minTouch } = useTheme();
  const want = useWantToRead();
  const actions = useWantToReadActions();
  const [busy, setBusy] = useState(false);
  if (!want.isSuccess) return null;
  const saved = want.data.find((b) => b.bookKey === bookKey);

  async function toggle() {
    setBusy(true);
    try {
      await (saved ? actions.remove(saved.id) : actions.add(editionId));
    } catch (err) {
      onError?.(err);
    }
    setBusy(false);
  }

  if (!saved) {
    return <Button variant="secondary" label={t('books.book.want')} icon={<BookmarkPlus size={18} color={colors.text} strokeWidth={1.75} />} loading={busy} onPress={() => void toggle()} />;
  }
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: space.sm, minHeight: minTouch }}>
      <BookmarkCheck size={20} color={colors.accent} strokeWidth={1.75} aria-hidden />
      <Text style={{ flex: 1, color: colors.text, fontSize: fontSize.md, fontWeight: '600' }}>{t('books.book.wanted')}</Text>
      <TextButton tone="muted" label={t('books.book.unwant')} onPress={() => void toggle()} disabled={busy} />
    </View>
  );
}
